<template>
  <div>
    <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
      <div class="d-flex justify-content-start">
        <h3><strong style="color:#1A0054">Colaboradores</strong></h3>
      </div>
      
      <div class="d-lg-flex d-md-flex d-sm-grid justify-content-center">
        <search-input-component 
          :search="search" 
          @onSearch="$emit('search', $event)"
        />
        
        <UserTableActions
          :download="download"
          @generate-users="$emit('generate-users')"
          @disable-users="$emit('disable-users')"
        />
      </div>
    </div>

    <h4 class="mb-4 text-utel">
      <strong>Listado de colaboradores</strong>
    </h4>
  </div>
</template>

<script>
import UserTableActions from './UserTableActions.vue'

export default {
  name: 'UserTableHeader',
  
  components: {
    UserTableActions
  },

  props: {
    search: { type: String, default: '' },
    download: { type: String, required: true }
  },

  emits: ['search', 'generate-users', 'disable-users']
}
</script>